import { Routes, Route } from 'react-router-dom';
import EditUser from './pages/UserEdit';
import UserList from './pages/UserList';
import { PERMISSIONS } from '../../constants/permissions';
import PermissionRoute from '../../routes/PermissionRoute';

function UserRoutes() {
  return (
    <Routes>
      <Route
        index
        element={
          <PermissionRoute requiredPermissions={[{ module: 'user', action: 'view' }]}>
            <UserList />
          </PermissionRoute>
        }
      />

      {/* Authorized users can edit users */}
      <Route
        path="edit"
        element={
          <PermissionRoute requiredPermissions={[{ module: 'user', action: 'edit' }]}>
            <EditUser />
          </PermissionRoute>
        }
      />

     

      {/* Unauthorized page */}
    </Routes>
  );
}

export default UserRoutes;
